import { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { FiLock, FiUser, FiLogIn, FiEye, FiEyeOff } from 'react-icons/fi';
import { useAuth } from '../contexts/AuthContext';
import { toast } from 'react-toastify';
import './Login.css';

const LOGIN_REDIRECT_DELAY_MS = 900;

const Login = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const { login, user, loading: authLoading } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!authLoading && user && user.role !== 'LocalAPI' && user.role !== 'CloudAPI') {
      navigate('/dashboard', { replace: true });
    }
  }, [authLoading, navigate, user]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    const result = await login(username, password);

    if (result.success) {
      toast.success('Đăng nhập thành công');
      setTimeout(() => {
        navigate('/dashboard');
      }, LOGIN_REDIRECT_DELAY_MS);
    } else {
      setLoading(false);
      setError(result.error);
      toast.error(result.error);
    }
  };

  return (
    <div className="min-h-screen bg-slate-900">
      <div className="grid min-h-screen w-full overflow-hidden bg-white/95 lg:grid-cols-[3fr_1fr]">
        <div className="relative hidden lg:block">
          <img
            src="/login.jpg"
            alt="GPACS Login"
            className="h-full w-full object-cover object-center"
            style={{ filter: 'contrast(1.08) saturate(1.08)' }}
          />
          <div className="absolute inset-0 bg-slate-900/10" />
        </div>

        <div className="flex items-center justify-center bg-white px-5 py-8 sm:px-8">
          <div className="w-full max-w-md">
            <div className="mb-6 text-center">
              <img src="/logo.png" alt="GPACS SYSTEM" className="mx-auto mb-3 h-16 w-auto object-contain" />
              <p className="mt-1 text-sm font-medium text-slate-600">GPACS - Hệ thống PACS tập trung</p>
            </div>

            {error && (
              <div className="mb-4 rounded-lg bg-red-50 px-3 py-2.5 text-sm text-red-600">
                {error}
              </div>
            )}

            <form onSubmit={handleSubmit} className="space-y-4">
              <div>
                <label className="mb-1.5 block text-sm font-medium text-slate-700">Tên đăng nhập</label>
                <div className="relative">
                  <FiUser className="pointer-events-none absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" />
                  <input
                    type="text"
                    className="w-full rounded-lg border border-slate-300 bg-white py-2.5 pl-10 pr-3 text-sm text-slate-800 outline-none transition focus:border-primary disabled:cursor-not-allowed disabled:bg-slate-100"
                    placeholder="Nhập tên đăng nhập"
                    value={username}
                    onChange={(e) => setUsername(e.target.value)}
                    required
                    disabled={loading}
                  />
                </div>
              </div>

              <div>
                <label className="mb-1.5 block text-sm font-medium text-slate-700">Mật khẩu</label>
                <div className="relative">
                  <FiLock className="pointer-events-none absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" />
                  <input
                    type={showPassword ? 'text' : 'password'}
                    className="w-full rounded-lg border border-slate-300 bg-white py-2.5 pl-10 pr-10 text-sm text-slate-800 outline-none transition focus:border-primary disabled:cursor-not-allowed disabled:bg-slate-100"
                    placeholder="Nhập mật khẩu"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    required
                    disabled={loading}
                  />
                  <button
                    type="button"
                    className="absolute right-2 top-1/2 -translate-y-1/2 rounded p-1 text-slate-500 transition-colors hover:text-primary disabled:cursor-not-allowed disabled:opacity-50"
                    onClick={() => setShowPassword(!showPassword)}
                    disabled={loading}
                    aria-label={showPassword ? 'Ẩn mật khẩu' : 'Hiện mật khẩu'}
                  >
                    {showPassword ? <FiEyeOff className="text-base" /> : <FiEye className="text-base" />}
                  </button>
                </div>
              </div>

              <button
                type="submit"
                className="inline-flex w-full items-center justify-center gap-2 rounded-lg bg-primary px-4 py-2.5 text-sm font-semibold text-white transition-colors hover:bg-primary-dark disabled:cursor-not-allowed disabled:opacity-50"
                disabled={loading}
              >
                {loading ? (
                  <>
                    <div className="h-4 w-4 animate-spin rounded-full border-2 border-white border-t-transparent"></div>
                    Đang đăng nhập...
                  </>
                ) : (
                  <>
                    <FiLogIn className="text-base" />
                    Đăng nhập
                  </>
                )}
              </button>
            </form>

              <div className="mt-4 text-center">
                <Link
                  to="/public/exams-search"
                  className="text-sm font-medium text-primary hover:text-primary-dark"
                >
                  Tra cứu ca chụp
                </Link>
              </div>

            <div className="mt-6 pt-4 text-center text-xs text-slate-500">
              <small>© 2025 GPACS System. All rights reserved.</small>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;

